<div class="row">
  <div class="col">
      <h2 class="h2-responsive"> Question Sets</h2>
      <!--TODO: stephen move this to <scales-list></scales-list>-->
      <p *ngIf="assessment.scales.length <= 0">No Question Sets exist</p>
  </div>
</div>
<div class="row">
  <div class="col-sm-4 col-lg-3">
    <ul class="list-group flex-column">
      <li class="list-group-item" 
        [ngClass]="getClassesForItem(questionSet)"
        *ngFor="let questionSet of assessment.question_sets;" (click)="selected = questionSet"><a>{{questionSet.title}}</a></li>
      </ul>
  </div>
  <div class="col-sm-8 col-lg-9" *ngIf="!selected">
    <p class="alert alert-info">Select a question set.</p>
  </div>
  <div class="col-sm-8 col-lg-9" *ngIf="selected">
    <h2>{{selected.title}}</h2>
    <table class="table table-striped">
      <thead class="secondary-color text-white">
        <th scope="col" class="w-50">Question</th>
        <th scope="col" class="w-50">Answers</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of selected.questions">
          <td>
              {{item.prompt}}
          </td>
          <td *ngIf="isTextItem(item)">
              <span>Text</span>
          </td>
          <td *ngIf="!isTextItem(item)">
              <span *ngFor="let lbl of getLabelsForSelected(selected, item);let first = first; let last = last;">
                {{lbl.label}}
                <span *ngIf="!last">,</span>
              </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/question-set-list-view/question-set-list-view.component.html